var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-page",class:{'base-welcome-popup' : _vm.welcomePopup.canShow},attrs:{"id":"app"}},[_c('DashboardLayout',{attrs:{"welcome-popup":_vm.welcomePopup},on:{"toggleSidebar":_vm.toggleSidebar}}),_vm._v(" "),_c('BaseFooter',{attrs:{"is-sidebar-opened":_vm.isSidebarOpened}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75c2010a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/TheDashboard.vue
// module id = null
// module chunks = 